import { ConfirmCancelModal } from '@/shared/components/ConfirmCancelModal'

export type LoiDeleteModalProps = {
  readonly open: boolean
  readonly isDeleting: boolean
  readonly onClose: () => void
  readonly onConfirm: () => void
}

export function LoiDeleteModal({
  open,
  isDeleting,
  onClose,
  onConfirm,
}: LoiDeleteModalProps) {
  return (
    <ConfirmCancelModal
      open={open}
      onStay={onClose}
      onConfirm={onConfirm}
      headline="Delete LOI"
      bodyLines={[
        'Are you sure you want to delete this LOI?',
        'This action cannot be undone.',
      ]}
      stayLabel="Cancel"
      confirmLabel={isDeleting ? 'Deleting…' : 'Delete'}
      confirmTone="danger"
      confirmDisabled={isDeleting}
      dialogTestId="loi-delete-dialog"
      confirmTestId="loi-delete-confirm"
    />
  )
}
